module.exports = __webpack_public_path__ + "img/device-name.6902d7a3.svg";